module.exports = __webpack_public_path__ + "img/comments-resolved.03732986.png";